import {
  FETCH_OWNER_LIST_REQUEST,
  FETCH_OWNER_LIST_SUCCESS,
  FETCH_OWNER_LIST_FAILURE,
  CREATE_OWNER_REQUEST,
  CREATE_OWNER_SUCCESS,
  CREATE_OWNER_FAILURE,
  UPDATE_OWNER_REQUEST,
  UPDATE_OWNER_SUCCESS,
  UPDATE_OWNER_FAILURE,
} from "../../../../actions/manage-property/property-owner/owner/types";

const initialState = {
  createOwner: { loading: false, data: null, error: null },
  deleteOwner: { loading: false, data: null, error: null },
  updateOwner: { loading: false, data: null, error: null },
  ownerList: { loading: false, data: null, error: null },
};

const OwnerList = (state = initialState, action) => {
  // console.log(action.type);
  switch (action.type) {
    //  Request
    case CREATE_OWNER_REQUEST:
      return {
        ...state,
        createOwner: { ...initialState.createOwner, loading: true },
      };
    case UPDATE_OWNER_REQUEST:
      return {
        ...state,
        updateOwner: { ...initialState.updateOwner, loading: true },
      };
    case FETCH_OWNER_LIST_REQUEST: {
      return {
        ...state,
        ownerList: { ...initialState.ownerList, loading: true },
      };
    }

// Success 
    case CREATE_OWNER_SUCCESS: {
      // console.log(state.ownerList);
      return {
        ...state,
        createOwner: {
          ...state.createOwner,
          payload: action.payload,
          loading: false,
          error: null,
        },
        ownerList: addNewOwnerData(action.payload, {
          ...state.ownerList,
        }),
      };
    }

    case UPDATE_OWNER_SUCCESS: {
      return {
        ...state,
        updateOwner: {
          ...state.updateOwner,
          loading: false,
          error: null,
          payload: action.payload,
        },
        ownerList: updateOwnerData(action.payload, {
          ...state.ownerList,
        }),
      };
    }

    case FETCH_OWNER_LIST_SUCCESS: {
      // console.log(action.payload);
      return {
        ...state,
        ownerList: {
          ...initialState.ownerList,
          loading: false,
          error: null,
          data: action.payload,
        },
      };
    }

    //failure
    case FETCH_OWNER_LIST_FAILURE:
      return {
        ...state,
        ownerList: { data: null, loading: false, error: action.error },
      };
      case CREATE_OWNER_FAILURE:
        return {
          ...state,
          createOwner: { data: null, loading: false, error: action.error }
        };
      case UPDATE_OWNER_FAILURE:
        return {
          ...state,
          updateOwner: { data: null, loading: false, error: action.error }
        };

    default:
      return state;
  }
};

function updateOwnerData(dataToUpdate, state) {
  state.data.data = state.data.data.map((obj) => {
    if (obj._id !== dataToUpdate._id) return obj;
    return { ...dataToUpdate };
  });

  return state;
}


function addNewOwnerData(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}

export default OwnerList;
